import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-cream mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <img
              src="/logo.png"
              alt="MZ Scents"
              className="h-16 w-auto object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="mt-6 text-sm leading-relaxed text-cream/70 max-w-md">
              Niche perfumery curated with intention. Each fragrance is a quiet
              ritual — composed of rare materials, precise craft, and an
              unhurried sense of style.
            </p>
          </div>

          <div>
            <div className="eyebrow text-gold mb-5">Shop</div>
            <ul className="space-y-3 text-sm text-cream/80">
              <li><Link to="/shop" className="hover:text-gold transition">All Perfumes</Link></li>
              <li><Link to="/shop/women" className="hover:text-gold transition">For Her</Link></li>
              <li><Link to="/shop/men" className="hover:text-gold transition">For Him</Link></li>
              <li><Link to="/shop/unisex" className="hover:text-gold transition">Unisex</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-gold mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-cream/80">
              <li>WhatsApp orders</li>
              <li>+92 318 0465911</li>
              <li>Lahore, Pakistan</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-xs text-cream/50">
          <div>© {new Date().getFullYear()} MZ Scents. All rights reserved.</div>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-gold transition">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
